import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('MANUFACTURER SERVICE');

@Injectable({
  providedIn: 'root'
})
export class ManufacturerService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'manufacturers' como el nombre del recurso a la clase base
    super('manufacturers');
    log.debug('Servicio de Fabricantes inicializado');
  }

}